<!--
  @author:chen.hao
  @time:2018/11/7
  @disc:报价管理
 -->

<template>
  <div class="supplier-manager" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="70px">
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="公司名称" prop="companyName">
        <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="userName"
        label="用户名"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="公司名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="product"
        label="报价商品"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="productCode"
        label="商品编码"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="商品报价"
        width="150px">
        <template slot-scope="scope">
          <template v-if="scope.row.quoteType===1">一口价:{{scope.row.fixedPrice}}元/吨</template>
          <template v-if="scope.row.quoteType===2">阶梯价: <p v-for="(item,index) in scope.row.stairPrice" :key="index">
            {{item.start}}-{{item.end}}吨，{{item.price}}元/吨</p>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        label="物流方案报价"
        width="200px">
        <template slot-scope="scope">
          首重{{scope.row.initialWeight}}吨，{{scope.row.initialCharge}}元/KM<br/>
          每增加{{scope.row.stepWeight}}吨，增加运费{{scope.row.stepCharge}}元/KM
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        show-overflow-tooltip
        :formatter="formatStatus">
      </el-table-column>
      <el-table-column
        label="操作"
        width="150px">
        <template slot-scope="scope">
          <el-button @click="infoView(scope.row)" v-permission="'0090102'">查看</el-button>
          <el-button v-if="scope.row.status===1" @click="review(scope.row)" v-permission="'0090101'">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <review-dialog :show.sync="reviewDialogShow" :info="reviewDialogInfo"></review-dialog>
    <info-view-dialog :show.sync="infoViewDialogShow" :info="infoViewDialogInfo"></info-view-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ReviewDialog from './reviewDialog'
import InfoViewDialog from './infoViewDialog'
export default {
  name: 'supplierManager',
  components: { InfoViewDialog, ReviewDialog },
  data () {
    return {
      statusArr: [
        { value: '', label: '全部' },
        { value: 1, label: '待审核' },
        { value: 3, label: '已审核' },
        { value: 2, label: '未通过' }
      ],
      form: {
        status: '',
        userName: '',
        companyName: ''
      },
      reviewDialogShow: false,
      reviewDialogInfo: '',
      infoViewDialogShow: false,
      infoViewDialogInfo: ''
    }
  },
  computed: {
    ...mapGetters({ list: 'getQuoteList', listState: 'getQuoteListState' })
  },
  methods: {
    ...mapActions([
      'getQuoteList',
      'getQuoteInfo']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.getQuoteList(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getQuoteList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getQuoteList({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 格式化状态
    formatStatus (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    },
    // 查看
    infoView (row) {
      this.getQuoteInfo({ id: row.id })
        .then(res => {
          this.infoViewDialogInfo = res
          this.infoViewDialogShow = true
        })
    },
    // 审核
    review (row) {
      this.getQuoteInfo({ id: row.id })
        .then(res => {
          this.reviewDialogInfo = res
          this.reviewDialogShow = true
        })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>

</style>
